import * as React from "react";
import { useMergeRefs } from "react-native-web-internals";
import useAnimatedProps from "./useAnimatedProps";
function createAnimatedComponent(Component) {
  return /* @__PURE__ */ React.forwardRef((props, forwardedRef) => {
    var _useAnimatedProps = useAnimatedProps(props), reducedProps = _useAnimatedProps[0], callbackRef = _useAnimatedProps[1];
    var ref = useMergeRefs(callbackRef, forwardedRef);
    var passthroughAnimatedPropExplicitValues = reducedProps.passthroughAnimatedPropExplicitValues, style = reducedProps.style;
    var _ref = passthroughAnimatedPropExplicitValues !== null && passthroughAnimatedPropExplicitValues !== void 0 ? passthroughAnimatedPropExplicitValues : {};
    const { passthroughStyle, ...passthroughProps } = _ref;
    var mergedStyle = [style, passthroughStyle];
    return /* @__PURE__ */ React.createElement(Component, {
      ...reducedProps,
      ...passthroughProps,
      style: mergedStyle,
      ref
    });
  });
}
export {
  createAnimatedComponent as default
};
//# sourceMappingURL=createAnimatedComponent.js.map
